import { motion } from "framer-motion";
import React from "react";
import { ImageComp } from "./ImageComp";

function ShowImg2({ imgs, dispatch, title }) {
  return (
    <>
      <ul className="desk--images">
        {imgs.map((i) => {
          return (
            <li key={i.id}>
              <motion.button
                onClick={(e) => {
                  dispatch({ type: "SELECTED", payload: e.target.id });
                }}
                whileTap={{ scale: 1.1 }}
              >
                <ImageComp image={i} id={i.id} alt={`${title} Designs`} />
              </motion.button>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export { ShowImg2 };
